module.exports = __webpack_public_path__ + "static/media/warning.3173d0dd.svg";